import { CartConsume } from "../Context_Ecommerce_Advance/CartContext";
import FormatePrice from "../Helper/FormatePrice";
import { FaTrash } from "react-icons/fa";
import CartQuantityToggle from "./CartQantityToggle";
const CartItems = ({ color, image, id, name, price, quantity }) => {
  // console.log(name);
  const { increasing, decreasing, removeItem } = CartConsume();
  return (
    <div className="cart_heading grid grid-five-column">
      <div className="cart-image--name">
        <div>
          <figure>
            <img src={image} alt={id} />
          </figure>
        </div>
        <div>
          <p>{name}</p>
          <div className="color-div">
            <p>color:</p>
            <p
              className="color-style"
              style={{ backgroundColor: color, color: color }}
            ></p>
          </div>
        </div>
      </div>
      {/* price   */}
      <div className="cart-hide">
        <p>
          <FormatePrice price={price} />
        </p>
      </div>

      {/* Quantity  */}
      <CartQuantityToggle
        quantity={quantity}
        decreasing={() => decreasing(id)}
        increasing={() => increasing(id)}
      />

      {/* //Subtotal */}
      <div className="cart-hide">
        <p>
          <FormatePrice price={price * quantity} />
        </p>
      </div>

      <div>
        <FaTrash className="remove_icon" onClick={() => removeItem(id)} />
      </div>
    </div>
  );
};
export default CartItems;
